import Vue from 'vue'
import App from './App.vue'
import Routes from './routes.js'

import firebase from 'firebase'
 import OtpInput from "@bachdgvn/vue-otp-input";
    const fb = require('./firebaseconfig.js')
  import VueRouter from 'vue-router'
  import VueAutosuggest from "vue-autosuggest";
Vue.use(VueAutosuggest);

  Vue.use(VueRouter)
  Vue.component("v-otp-input", OtpInput);

Vue.use(VueAutosuggest);


  const router=new VueRouter({

routes:Routes,
mode:'history'

  })



    router.beforeEach((to,from,next)=>{
    
 


 
 let cu=fb.auth.currentUser;

 let ra=to.matched.some(record=>record.meta.requiresAuth)
 
   if(ra && !cu){

  next()

  }else if(!ra &&  cu ){

  next()

 }else{
  next()
 }

})



  let app;


window.addEventListener('load', function () {
    //your script

  fb.auth.onAuthStateChanged((user)=>{



    app=new Vue({
  el: '#app',
  render: h => h(App),
  router:router
})})


  })

 


// WEBPACK FOOTER //
// ./src/main.js